"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MainAttributes;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _CharacterStatsWindowModule = _interopRequireDefault(require("../../CharacterStatsWindow.module.scss"));

var _MainAttributesModule = _interopRequireDefault(require("./MainAttributes.module.scss"));

var _CharacterStatsWindow = _interopRequireDefault(require("../../CharacterStatsWindow.i18n"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MainAttributes(_ref) {
  var attributePoints = _ref.attributePoints,
      mainAttributes = _ref.mainAttributes,
      mainAttributeBonuses = _ref.mainAttributeBonuses;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var vitality = mainAttributes.vitality,
      dexterity = mainAttributes.dexterity,
      intelligence = mainAttributes.intelligence,
      strength = mainAttributes.strength;
  var vitalityBonus = mainAttributeBonuses.vitality,
      dexterityBonus = mainAttributeBonuses.dexterity,
      intelligenceBonus = mainAttributeBonuses.intelligence,
      strengthBonus = mainAttributeBonuses.strength;
  /*
    TODO
    const isVitColorized={colorizedVit}
    const isDexColorized={colorizedDex}
    const isIntColorized={colorizedInt}
    const isStrColorized={colorizedStr}
    */

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainAttributesModule.default.mainAttributes, _CharacterStatsWindowModule.default.mainAttributes)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.vit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.title
  }, formatMessage(_CharacterStatsWindow.default.vit)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PC_ADD,
    className: _MainAttributesModule.default.btn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.value
  }, vitality, vitalityBonus > 0 && "+".concat(vitalityBonus))), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.dex
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.title
  }, formatMessage(_CharacterStatsWindow.default.dex)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PC_ADD,
    className: _MainAttributesModule.default.btn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.value
  }, dexterity, dexterityBonus > 0 && "+".concat(dexterityBonus))), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.int
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.title
  }, formatMessage(_CharacterStatsWindow.default.int)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PC_ADD,
    className: _MainAttributesModule.default.btn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.value
  }, intelligence, intelligenceBonus > 0 && "+".concat(intelligenceBonus))), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.str
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.title
  }, formatMessage(_CharacterStatsWindow.default.str)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PC_ADD,
    className: _MainAttributesModule.default.btn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.value
  }, strength, strengthBonus > 0 && "+".concat(strengthBonus))), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.points
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.title
  }, formatMessage(_CharacterStatsWindow.default.points)), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainAttributesModule.default.value
  }, attributePoints)));
}